import { render } from "./WordCard.vue?vue&type=template&id=5edc06a1&scoped=true"
import script from "./WordCard.vue?vue&type=script&lang=js"
export * from "./WordCard.vue?vue&type=script&lang=js"

import "./WordCard.vue?vue&type=style&index=0&id=5edc06a1&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5edc06a1"]])

export default __exports__